import React from "react"
import styled from "styled-components"
import map from "lodash/map"

import PostCard from "./PostCard"

const Posts = ({ posts, type }) => {
  const renderPosts = () =>
    map(posts.edges.reverse(), ({ node }) => (
      <PostCard key={node.id} post={node} type={type} authors={null} />
    ))

  return (
    <StyledPosts className="posts">
      <ul className="postsList">{renderPosts()}</ul>
    </StyledPosts>
  )
}

const StyledPosts = styled.div`
  width: 100%;

  .postsList {
    width: 100%;
    display: grid;
    justify-content: center;
    grid-template-columns: 1fr;
    grid-gap: var(--sp-32);
  }
`

Posts.defaultProps = {}

export default Posts
